import React from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { brand } from "../config/brand";

function Hero() {
  const { t } = useTranslation();

  return (
    <div className="relative isolate overflow-hidden px-6 pt-14 lg:px-8">
      {/* angled signal beam behind the headline */}
      <div className="pointer-events-none absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-72" aria-hidden="true">
        <div
          className="relative left-[calc(50%-18rem)] aspect-[1155/678] w-[40rem] -translate-x-1/2 rotate-[28deg] bg-gradient-to-tr from-signal-500 to-signal-300 opacity-20 sm:left-[calc(50%-24rem)] sm:w-[72rem]"
          style={{
            clipPath:
              "polygon(74% 44%, 100% 61%, 97% 26%, 85% 0, 80% 2%, 72% 32%, 60% 62%, 52% 68%, 47% 58%, 45% 34%, 27% 76%, 0 64%, 17% 100%, 27% 76%, 76% 97%, 74% 44%)",
          }}
        />
      </div>

      <div className="mx-auto max-w-3xl py-28 sm:py-36 lg:py-40">
        <div className="mb-8 flex justify-center animate-fade-up" style={{ animationDelay: '0.05s' }}>
          <Link
            to="/contacts"
            className="group relative rounded-full bg-white/5 px-4 py-1.5 text-sm leading-6 text-ink-300 ring-1 ring-white/10 transition hover:ring-signal-500/40"
          >
            {t('hero-contact-us')}{' '}
            <span className="font-semibold text-signal-400">
              {t('hero-redirect')}{' '}
              <span aria-hidden="true" className="inline-block transition-transform group-hover:translate-x-0.5">&rarr;</span>
            </span>
          </Link>
        </div>

        <div className="text-center">
          <h1
            className="font-display text-5xl font-extrabold uppercase italic leading-[0.95] tracking-tight text-ink-100 animate-fade-up sm:text-7xl"
            style={{ animationDelay: '0.12s' }}
          >
            {t('hero-title')}
          </h1>
          <p
            className="mx-auto mt-6 max-w-xl text-lg leading-8 text-ink-300 animate-fade-up"
            style={{ animationDelay: '0.2s' }}
          >
            {t('hero-text')}
          </p>

          <div
            className="mt-10 flex flex-col items-center justify-center gap-4 animate-fade-up sm:flex-row sm:gap-6"
            style={{ animationDelay: '0.28s' }}
          >
            <Link
              to="/tracking"
              className="group inline-flex items-center gap-2 rounded-full bg-signal-500 px-7 py-3 text-sm font-bold uppercase tracking-wide text-white shadow-glow transition-all hover:bg-signal-400 hover:shadow-[0_0_0_1px_rgba(251,22,21,0.4),0_22px_50px_-12px_rgba(251,22,21,0.58)]"
            >
              {t('hero-tracking')}
              <span aria-hidden="true" className="transition-transform group-hover:translate-x-1">&rarr;</span>
            </Link>
            <Link
              to={brand.cabinetUrl}
              target="_blank"
              className="inline-flex items-center gap-2 rounded-full border border-white/15 px-7 py-3 text-sm font-semibold uppercase tracking-wide text-ink-100 transition-all hover:border-signal-500/40 hover:text-signal-400"
            >
              {t('hero-cabinet')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
